"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateCreateUserAttribute = void 0;
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userAttributeCreateQuery = (0, graphql_tag_1.default) `mutation UserAttributeCreate(
    $workspaceId: ID!,
    $name: String!,
    $shortName: String,
    $type: CustomAttributeValueType!,
    $description: String,
    $customId: String,
    $hidden: Boolean,
    $options: CustomAttributeOptionsInput
      ) {
      userAttributeCreate(
        workspace: $workspaceId,
        name: $name,
        shortName: $shortName,
        type: $type,
        description: $description,
        customId: $customId,
        hidden: $hidden,
        options: $options
       ) {
       id
       name
       description
       shortName
       customId
       type
       options {
         values
       }
       hidden
  }
}`;
const mutateCreateUserAttribute = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(userAttributeCreateQuery, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.userAttributeCreate;
};
exports.mutateCreateUserAttribute = mutateCreateUserAttribute;
/**
* @deprecated Use `mutateCreateUserAttribute` instead
*/
async function createUserAttributes(variables) {
    const response = await (0, util_1.fetchRequest)({ query: userAttributeCreateQuery, variables });
    if (!response)
        return util_1.errorUtil.noResponse();
    // @ts-expect-error
    const { errors, data } = response;
    if (errors) {
        return util_1.errorUtil.apiError('', errors);
    }
    return data.userAttributeCreate;
}
exports.default = createUserAttributes;
